import { render, staticRenderFns } from "./CommandBreak.vue?vue&type=template&id=5b812efe&scoped=true&"
import script from "./CommandBreak.vue?vue&type=script&lang=ts&"
export * from "./CommandBreak.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b812efe",
  null
  
)

export default component.exports